import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "../stores/api";
import { getRecaptchaToken } from "../utils/recaptcha";

export type ConfirmRequest = {
	campaignId: string;
	advisorId: number;
	prospectFirstname: string;
	prospectLastname: string;
	prospectEmail: string;
	slotStart: string;
	slotEnd: string;
	timezone: string;
	attribution: Record<string, string>;
};

export type ConfirmResponse = {
	calendarEventId: string;
	calendarEventLink: string;
};

async function confirmBooking(req: ConfirmRequest): Promise<ConfirmResponse> {
	const recaptchaToken = await getRecaptchaToken();
	return apiFetch("POST", `/voice/campaign/${req.campaignId}/book`, {
		json: {
			advisor_id: req.advisorId,
			prospect_firstname: req.prospectFirstname,
			prospect_lastname: req.prospectLastname,
			prospect_email: req.prospectEmail,
			slot_start: req.slotStart,
			slot_end: req.slotEnd,
			timezone: req.timezone,
			attribution: req.attribution,
			recaptcha_token: recaptchaToken ?? null,
		},
	});
}

export function useConfirmBooking(
	onSuccess: (res: ConfirmResponse) => void,
	onError: () => void,
) {
	return useMutation<ConfirmResponse, unknown, ConfirmRequest>({
		mutationFn: confirmBooking,
		onSuccess,
		onError,
	});
}
